export type SupportedLanguage = 'en' | 'de' | 'fr' | 'es' | 'pt' | 'nl';
export const SUPPORTED_LANGUAGES: SupportedLanguage[] = ['en', 'de', 'fr', 'es', 'pt', 'nl'];
import { getLang as getBpLang } from '@beeline.com/bp-intl';

export function getLang(): SupportedLanguage {
  return getBpLang(SUPPORTED_LANGUAGES);
}
